export default {
  GET_FONTS_REQUEST: 'GET_FONTS_REQUEST',
  SET_DATA_OF_FONTS: 'SET_DATA_OF_FONTS',
  UNSELECT_FONT_REQUEST: 'UNSELECT_FONT_REQUEST',
  UNSELECT_FONT: 'UNSELECT_FONT',
  SELECT_FONT_REQUEST: 'SELECT_FONT_REQUEST',
  SELECT_FONT: 'SELECT_FONT',
  SET_FONTS_FRESH_STATUS: 'SET_FONTS_FRESH_STATUS',
};
